import React, { Component } from 'react';
import PropTypes from 'prop-types';
import API_URL from '../../../../common/url';
import HeaderBar from '../../components/HeaderBar';
import TablePage from './TablePage';
import ChartsCollection from '../components/ChartsCollection';
import { genSubAuth } from '../../constants';

const countType = 2;
const Icons = [{ icon: '\ue659', order: 0 }, { icon: '\ue651', order: 1 }, { icon: '\ue656', order: 2 }];
function getCharts(type, angle) {
    const chartTitle = angle === '0' ? '发票金额(含税总额)总金额' : '请款笔数';
    return (
        [{
            title: '超账期天数',
            chartTitle,
            type,
            key: 'overPaymentDays',
            queryUrl: API_URL.requestDataAnalysis.queryOutCashReqNodeDaysCount,
            exportUrl: API_URL.requestDataAnalysis.exportOutCashReqNodeDaysCount,
        }, {
            title: '超期原因',
            chartTitle,
            type,
            key: 'overPaymentReason',
            queryUrl: API_URL.requestDataAnalysis.queryRemark,
            exportUrl: API_URL.requestDataAnalysis.exportRemark,
        }, {
            title: '客户',
            chartTitle,
            type,
            key: 'client',
            queryUrl: API_URL.requestDataAnalysis.queryCustomer,
            exportUrl: API_URL.requestDataAnalysis.exportCustomer,
        }]
    );
}

class InvoicedUnreturned extends Component {
    static contextTypes = {
        businessList: PropTypes.array,
        clientHeight: PropTypes.number,
        notice: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            searchParams: {
                type: '0',
            },
        };
    }

    handleIconChange = (current) => {
        this.setState({ current });
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    render() {
        const { businessList, clientHeight, notice } = this.context;
        const { auth } = this.props;
        const { current, searchParams } = this.state;
        const { type } = searchParams;

        return (
            <div className="pane-item">
                <HeaderBar
                    title="已开票未回款清单"
                    tip="已存在开票日期，不存在收款日期的请款记录"
                    onChange={this.handleIconChange}
                    current={current}
                    icons={Icons}
                />
                {
                    current === 0 &&
                    <TablePage
                        notice={notice}
                        searchParams={searchParams}
                        businessList={businessList}
                        clientHeight={clientHeight}
                        onChange={this.handleChange}
                    />
                }
                {
                    current === 1 &&
                    genSubAuth(auth, 'histogram') &&
                    <ChartsCollection
                        countType={countType}
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        onChange={this.handleChange}
                        charts={getCharts('histogram', type)}
                        auth={genSubAuth(auth, 'histogram')}
                    />
                }
                {
                    current === 2 &&
                    genSubAuth(auth, 'pie') &&
                    <ChartsCollection
                        countType={countType}
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        onChange={this.handleChange}
                        charts={getCharts('pie', type)}
                        auth={genSubAuth(auth, 'pie')}
                    />
                }
            </div>
        );
    }
}

export default InvoicedUnreturned;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/InvoicedUnreturned/index.js